module.exports = "/_next/static/images/rabbit-9df5bb1a472d215f93823ef2d747d558.svg";